import { rem, Flex, Button, Paragraph, Header } from '@vimeo/bokeh';
import { createInteractionDomName } from '@vimeo/cloud-live/libs/shared/utils/dom/identifying';
import { translations } from '@vimeo/cloud-live/translations';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { EInteractionAuthOption } from '@vimeo/live-core/types/interaction_room';

import { VimeoUserLogin } from './VimeoUserLogin';

/**
 * Admin login option for users who have moderation/creation access in the event.
 */
export function AdminLogin({ id = createInteractionDomName('admin-login') }: IBaseDomElementProps) {
  return (
    <Flex
      id={id}
      flexDirection={'column'}
      alignItems={'center'}
      textAlign={'center'}
      padding={`${rem(8)} ${rem(16)}`}
      maxWidth={rem(480)}
      margin={`${rem(16)} ${rem(16)} ${rem(24)} ${rem(16)}`}
      borderRadius={rem(8)}
      backgroundColor={'background-blur'}
    >
      <Header size={'xs'}>{translations.moderatorLogIn}</Header>
      <Paragraph size={'md'} color={'text-secondary'}>
        {translations.ifYouAreModeratorForThisEvent}
      </Paragraph>

      <VimeoUserLogin
        id={id}
        loginType={EInteractionAuthOption.ADMIN}
        buttonRenderer={({ label, ...props }) => (
          <Button size={'md'} variant={'tertiary'} flexShrink={0} {...props}>
            {label}
          </Button>
        )}
      />
    </Flex>
  );
}
